import { reskinStyles } from 'core/components/theme/theme-variant';

export default (theme) => ({
  // Reskin: the drop zone is a beige inset that clips its hover fill and progress bar to its rounded corners.
  root: reskinStyles(theme, { ...theme.cardStyles.inset, position: 'relative', overflow: 'hidden' }),
  dropzoneButton: {
    width: '100%',
    height: 60
  },
  dropzoneContainer: {
    position: 'relative',
    height: 60
  },
  progressBar: {
    position: 'absolute',
    width: '100%'
  },
  // Reskin: no orange track line while nothing is uploading or deleting.
  progressIdle: reskinStyles(theme, { visibility: 'hidden' }),
  error: {
    color: theme.colorPalette.red_50,
    '&:hover': {
      background: 'none'
    }
  }
});
